import { render, staticRenderFns } from "./Digits.vue?vue&type=template&id=84245928&lang=pug&"
import script from "./Digits.vue?vue&type=script&lang=ts&"
export * from "./Digits.vue?vue&type=script&lang=ts&"
import style0 from "./Digits.vue?vue&type=style&index=0&id=84245928&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports